import { ComponentPropsWithoutRef } from 'react';

export const EnvelopeIcon = ({ ...props }: ComponentPropsWithoutRef<'svg'>) => {
  return (
    <svg {...props} viewBox="0 0 14 11" fill="none">
      <path
        d="M1.685 10.833c-.367 0-.68-.13-.941-.392A1.286 1.286 0 0 1 .352 9.5v-8c0-.366.13-.68.392-.941.26-.26.575-.392.94-.392h10.668c.366 0 .68.13.942.392.26.261.391.575.39.941v8c0 .367-.13.681-.39.942a1.28 1.28 0 0 1-.942.392H1.685Zm5.333-4.667 5.334-3.333V1.499L7.018 4.833 1.685 1.499v1.334l5.333 3.333Z"
        fill="#000000"
      />
    </svg>
  );
};
